import { Suspense } from "react";
import HeaderWebsite from "../../components/HeaderWebsite";
import Afilhado from "../../components/Afilhado";

export default function AffiliatePage(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
  } = props;

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <Afilhado />
      </Suspense>
    </>
  );
}
